import React, { useState, useContext } from 'react';
import { RicosContext, ModalContext } from 'ricos-context';
import { HTMLData_Source } from 'ricos-schema';
import { Node_Type } from 'ricos-types';
import { ToggleButton, EditIcon } from 'wix-rich-content-toolbars-ui';

const HTML_EDIT_MODAL_ID = `${Node_Type.HTML}.edit`;
const EditHtmlButton = ({ toolbarItem, dataHook }) => {
  var _a, _b, _c, _d;
  const [referenceElement, setReferenceElement] = useState(null);
  const { t } = useContext(RicosContext) || {};
  const modalService = useContext(ModalContext);
  const node = toolbarItem.attributes.selectedNode;
  const componentData = {
    srcType: ((_a = node == null ? void 0 : node.attrs) == null ? void 0 : _a.html) ? "html" : "url",
    src: ((_b = node == null ? void 0 : node.attrs) == null ? void 0 : _b.html) || ((_c = node == null ? void 0 : node.attrs) == null ? void 0 : _c.url),
    config: {
      isAdsense: ((_d = node == null ? void 0 : node.attrs) == null ? void 0 : _d.source) === HTMLData_Source.ADSENSE
    }
  };
  const updateData = (data) => {
    var _a2;
    const htmlData = data.srcType === "html" ? { html: data.src, url: null } : { url: data.src, html: null };
    (_a2 = toolbarItem.commands) == null ? void 0 : _a2.click({ htmlData });
  };
  const onClick = () => {
    const isModalOpen = modalService.isModalOpen(HTML_EDIT_MODAL_ID);
    isModalOpen ? modalService.closeModal(HTML_EDIT_MODAL_ID) : modalService.openModal(HTML_EDIT_MODAL_ID, {
      componentProps: {
        componentData,
        updateData,
        close: () => modalService.closeModal(HTML_EDIT_MODAL_ID)
      },
      layout: "popover",
      positioning: { referenceElement, placement: "bottom" }
    });
  };
  return /* @__PURE__ */ React.createElement("div", { ref: setReferenceElement }, /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      dataHook,
      Icon: EditIcon,
      label: t("HtmlPlugin_EditHtml_Tooltip"),
      tooltip: t("HtmlPlugin_EditHtml_Tooltip"),
      onClick
    }
  ));
};

export { EditHtmlButton };
//# sourceMappingURL=EditHtmlButton.js.map
